import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';
import './About.css';
import { Link } from 'react-router-dom';
import Peterpic from '../Assets/Peterpic.png';
import Sannidhanpic from '../Assets/Sannidhanpic.png';
import Jasonpic from '../Assets/Jasonpic.png';
import Dabbispic from '../Assets/Dabbispic.png';

const About = () => {
  return (
    <div className="about-container">
      <Navbar />

      {/* Hero Section */}
    <header className="about-hero hero-bg about-page-section"><motion.div
  className="about-hero-content"
  initial={{ opacity: 0, y: 20 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: false, amount: 0.4 }}
  transition={{ duration: 1 }}
>
          <h1>Precision Intelligence for a Complex World</h1>
          <div className="separator"></div>
        </motion.div>



      </header>


        
{/* Meaning Section */}
<div className="story-bg-group">
<section className="about-meaning-section about-page-section">
   <motion.div
    className="meaning-wrapper"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 1 }}
    viewport={{ once: false, amount: 0.3 }}
  >
    <h2 className="meaning-title">
      What Does Sapiencia Mean?
    </h2>

    <div className="meaning-underline"></div>

<p>
  Sapiencia comes from the Latin word <strong>sapientia</strong>, which means wisdom, discernment, deep knowledge or understanding, and the ability to apply intelligence wisely.
</p>

<p>
  It is the same root found in words like <strong>sapient</strong> (wise or intelligent) and <strong>Homo sapiens</strong> (wise human).
</p>

<p>
  Sapiencia conveys the idea of intelligent insight, applied wisdom, knowledge turned into action, and thoughtful, informed decision-making.
</p>



    <div className="company-nav-buttons">
      <Link to="/partners" className="company-nav-btn">
        Partners
      </Link>

      <Link to="/capabilities" className="company-nav-btn outline-company-btn">
        Capabilities
      </Link>
    </div>
  </motion.div>
</section>

<motion.div
  className="section-divider"
  initial={{ opacity: 0, scaleX: 0 }}
  whileInView={{ opacity: 1, scaleX: 1 }}
  transition={{ duration: 0.8, ease: "easeOut" }}
  viewport={{ once: false, amount: 0.8 }}
/>

<section className="about-mission about-page-section">        
  <div className="about-grid">
          <motion.div 
            className="about-image"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: false, amount: 0.3 }}
          >
            <div className="about-image">
              <img 
                src="/logo_motion.gif" 
                alt="Animated representation" 
              />
             
            </div> 
          </motion.div>

          <motion.div 
            className="about-content"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: false, amount: 0.3 }}
          >
            <h2>Our Mission</h2>
            <div className="underline"></div>
            <p>We build the AI that the world's most critical missions depend on — advancing research, engineering trusted solutions, and pushing the boundaries of what's possible in Defense, Healthcare, and Cybersecurity.</p>
            <p>Founded by leading security experts and researchers, we combine deep technical mastery with sector-specific insight across defense, healthcare, and cybersecurity.</p>
          </motion.div>
        </div>
      </section>

<motion.div
  className="section-divider"
  initial={{ opacity: 0, scaleX: 0 }}
  whileInView={{ opacity: 1, scaleX: 1 }}
  transition={{ duration: 0.8, ease: "easeOut" }}
  viewport={{ once: false, amount: 0.8 }}
/>

      {/* Values Section */}
      <section className="about-values about-page-section">       
         <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: false, amount: 0.3 }}
        >
          Our Core Values
        </motion.h2>
        <div className="values-grid">
          {["Security First", "Ethical Innovation", "Regulatory Excellence", "Meaningful Impact"].map((value, idx) => (
            <motion.div
              key={value}
              className="value-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: idx * 0.1 }}
              viewport={{ once: false, amount: 0.3 }}
              whileHover={{ y: -10 }}
            >
              <div className={`value-icon ${value.toLowerCase().replace(/ /g, '-')}`}></div>
              <h3>{value}</h3>
              <p>{
                [
                  'We build products with security as the foundation, not an afterthought. Every decision we make prioritizes the protection of sensitive data and critical infrastructure.',
                  'We push the boundaries of AI while maintaining the highest ethical standards. Our innovations are designed to enhance human capabilities, not replace them.',
                  'We excel at navigating complex regulatory landscapes, ensuring our solutions exceed compliance requirements while remaining adaptable to evolving standards.',
                  'We measure our success by the tangible difference our technology makes for our clients and the people they serve, from patients to military personnel.'
                ][idx]
              }</p>
            </motion.div>
          ))}
        </div>
      </section>
    </div>

<motion.div
  className="section-divider"
  initial={{ opacity: 0, scaleX: 0 }}
  whileInView={{ opacity: 1, scaleX: 1 }}
  transition={{ duration: 0.8, ease: "easeOut" }}
  viewport={{ once: false, amount: 0.8 }}
/>
      {/* Team Section */}
      <div className="team-bg-group">


      <section className="about-team about-page-section">         <motion.div 
          className="team-content"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <h2>Leadership Team</h2>
          <div className="underline"></div>
          <p>Our leadership team brings together decades of experience in artificial intelligence, cybersecurity, healthcare IT, and defense technology. With backgrounds ranging from the Department of Defense and intelligence agencies to leading research institutions and healthcare organizations, our team understands the critical intersection of security, compliance, and innovation.</p>
        </motion.div>

        <div className="team-grid">
         {[
  {
    name: 'Dabis Camero',
    role: 'Innovative Leader in AI/ML, Cybersecurity, and IAM Solutions',
    desc: 'AI/ML and Cybersecurity expert specializing in IAM, IGA, and next-gen security solutions',
    image: Dabbispic
  },
  {
    name: 'Peter Kuchnia',
    role: 'Director of Cybersecurity | Cyber Risk Management & Resilience | Cyber Strategic Advisor',
    desc: 'Cybersecurity expert helping businesses stay secure with IAM, risk management, and cyber resilience',
    image: Peterpic
  },
  {
    name: 'Dr. Jason Elroy Martis',
    role: 'Associate Professor',
    desc: 'Expert in Deep Learning, Computer Vision, and AI with 15+ years of research and teaching experience',
    image: Jasonpic
  },
  {
    name: 'Dr. Sannidhan M S',
    role: 'Associate Professor',
    desc: 'Expert in Image Processing, Machine Learning, and Quantum AI, with a strong passion for research and teaching',
    image: Sannidhanpic
  },
].map((member, idx) => (
            <motion.div
              key={member.name}
              className="team-member"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: idx * 0.1 }}
              viewport={{ once: false, amount: 0.3 }}
              whileHover={{ y: -5 }}
            >
            <div className="member-photo">
            {member.image && (
            <img src={member.image} alt={member.name} />
              )}
          </div>              
            <h3>{member.name}</h3>
              <p>{member.role}</p>
              <span>{member.desc}</span>
            </motion.div>
          ))}
        </div>
      </section>

<motion.div
  className="section-divider"
  initial={{ opacity: 0, scaleX: 0 }}
  whileInView={{ opacity: 1, scaleX: 1 }}
  transition={{ duration: 0.8, ease: "easeOut" }}
  viewport={{ once: false, amount: 0.8 }}
/>
      {/* Approach Section */}
<section className="about-approach about-page-section">         
         <img
         
            />

        <motion.div 
          className="approach-content"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <h2>Our Approach</h2>
          <div className="underline"></div>
          <p>We believe that true security comes from a deep understanding of both the technological landscape and the human elements at play. Our approach combines:</p>
          <div className="approach-points">
            {[
              { title: 'Rigorous AI Ethics', desc: 'Every solution we build undergoes extensive ethical review to ensure responsible AI deployment.' },
              { title: 'Security by Design', desc: "Security isn't an add-on—it's woven into every line of code and every system architecture decision." },
              { title: 'Human-Centered Solutions', desc: 'We design for the people who use our systems, ensuring intuitive interfaces that enhance decision-making.' },
              { title: 'Continuous Adaptation', desc: 'Our solutions evolve with the threat landscape, continuously learning and improving.' },
            ].map((item, i) => (
              <motion.div
                key={item.title}
                className="approach-point"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: (i + 1) * 0.1 }}
                viewport={{ once: false, amount: 0.3 }}
              >
                <span>{`0${i + 1}`}</span>
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </section>

      {/* CTA Section */}
      <section className="about-cta about-page-section">       
         <motion.div 
          className="cta-content"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <h2>Join Us in Our Mission</h2>
          <p>Whether you're looking to secure your healthcare data, enhance defense operations, or join our team, we invite you to be part of our journey toward a more secure future.</p>
          <div className="cta-buttons">
            <Link to="/contact" className="cta-button">Contact Us</Link>
            <Link to="/careers" className="outline-button">Explore Careers</Link>
          </div>
        </motion.div>
      </section>
      </div>

      {/* Shared Footer */}
      <Footer />
    </div>
  );
};

export default About;